import { Children, ReactNode } from 'react';

export type DataGridCellProps = {
  /** Cell content - can be single element or multiple elements that stack vertically */
  children: ReactNode;
  /** Additional CSS classes to apply */
  className?: string;
  /** Text alignment for the cell content */
  align?: 'left' | 'center' | 'right';
  /** Truncate text content with ellipsis when it overflows (default: true) */
  truncate?: boolean;
};

const alignClasses = {
  left: 'items-start text-left',
  center: 'items-center text-center',
  right: 'items-end text-right',
};

function DataGridCell({
  children,
  className = '',
  align = 'left',
  truncate = true,
}: Readonly<DataGridCellProps>) {
  if (truncate) {
    const childArray = Children.toArray(children);
    return (
      <div
        className={`flex min-w-0 flex-col gap-0.5 overflow-hidden ${alignClasses[align]} ${className}`}
      >
        {childArray.map((child, i) => (
          <div key={i} className="min-w-0 truncate">
            {child}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div
      className={`flex min-w-0 flex-col gap-0.5 ${alignClasses[align]} ${className}`}
    >
      {children}
    </div>
  );
}

DataGridCell.displayName = 'DataGridCell';

export default DataGridCell;
